export default {
  pautas: [],
  pauta: {},
  pagination: {},
};
